import {useContext} from 'react'
import {Container} from './components/Container'
import {CustomLanding36252Context} from '../../../../../../reducer'
import {t} from '../../../../../../i18n'
import {CustomLanding36252ActionType} from '../../../../../../types'

type LanguageProps = {
  code: string
}

export const Language = ({code}: LanguageProps): React.ReactElement => {
  const [state, dispatch] = useContext(CustomLanding36252Context)
  const label = t[code].langName

  const handleClick = () => {
    dispatch?.({
      type: CustomLanding36252ActionType.ChangeLanguageAction,
      payload: code,
    })
  }
  return (
    <Container onClick={handleClick} selected={state.language === code}>
      {label}
    </Container>
  )
}
